(function () {
  if (window.__noblecutSizeRecommenderFittingLoaded) return;
  window.__noblecutSizeRecommenderFittingLoaded = true;

  const root = document.getElementById("size-recommender-fitting");
  const modal = document.getElementById("srfModal");

  if (!root || !modal) return;

  const SIZE_CHARTS = {
    size_hemd: {
      label: "Hemd",
      sizes: [
        { size: "38", alpha: "S", halfChest: 51, halfSeat: 49, shoulder: 15.0, sleeve: 66.0 },
        { size: "39", alpha: "M", halfChest: 53, halfSeat: 51, shoulder: 15.5, sleeve: 66.5 },
        { size: "40", alpha: "M", halfChest: 55, halfSeat: 53, shoulder: 16.0, sleeve: 67.0 },
        { size: "41", alpha: "L", halfChest: 57, halfSeat: 55, shoulder: 16.5, sleeve: 67.5 },
        { size: "42", alpha: "XL", halfChest: 59, halfSeat: 57, shoulder: 17.0, sleeve: 68.0 }
      ]
    },

    size_pullover: {
      label: "Pullover",
      sizes: [
        { size: "XS / S", alpha: "S", halfChest: 50, halfHem: 42, shoulder: 40, length: 67, sleeve: 65 },
        { size: "S / M", alpha: "M", halfChest: 52, halfHem: 44, shoulder: 42, length: 69, sleeve: 66 },
        { size: "M / L", alpha: "L", halfChest: 54, halfHem: 46, shoulder: 44, length: 71, sleeve: 67 },
        { size: "L / XL", alpha: "XL", halfChest: 56, halfHem: 48, shoulder: 46, length: 73, sleeve: 68 }
      ]
    },

    size_hose: {
      label: "Hose",
      sizes: [
        { size: "46", alpha: "S", halfWaist: 41, halfKnee: 25, halfHem: 18.0, halfThigh: 34 },
        { size: "48", alpha: "M", halfWaist: 43, halfKnee: 25.5, halfHem: 18.5, halfThigh: 35 },
        { size: "50", alpha: "L", halfWaist: 45, halfKnee: 26, halfHem: 19.0, halfThigh: 36 },
        { size: "52", alpha: "XL", halfWaist: 47, halfKnee: 26.5, halfHem: 19.5, halfThigh: 37 },
        { size: "54", alpha: "XXL", halfWaist: 49, halfKnee: 27, halfHem: 20.0, halfThigh: 38 }
      ]
    }
  };

  const SIZE_ORDER = ["XS", "S", "M", "L", "XL", "XXL"];

  const state = {
    currentStep: 1,
    productType: null,
    userInput: {
      height: null,
      weight: null,
      usualSize: null,
      fit: null
    }
  };

  const wizard = document.getElementById("srfWizard");
  const resultView = document.getElementById("srfResultView");
  const footer = document.getElementById("srfFooter");
  const productSubtitle = document.getElementById("srfProductSubtitle");

  const heightInput = document.getElementById("srfHeight");
  const weightInput = document.getElementById("srfWeight");

  const backButton = document.getElementById("srfBackButton");
  const nextButton = document.getElementById("srfNextButton");
  const doneButton = document.getElementById("srfDoneButton");
  const restartButton = document.getElementById("srfRestartButton");

  const resultIntro = document.getElementById("srfResultIntro");
  const resultsContainer = document.getElementById("srfResults");

  const stepTypeError = document.getElementById("srfStepTypeError");
  const step1Error = document.getElementById("srfStep1Error");
  const step2Error = document.getElementById("srfStep2Error");
  const step3Error = document.getElementById("srfStep3Error");

  root.querySelector("[data-srf-open]")?.addEventListener("click", openModal);

  document.querySelectorAll("[data-srf-close]").forEach(element => {
    element.addEventListener("click", closeModal);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && modal.classList.contains("is-open")) {
      closeModal();
    }
  });

  document.querySelectorAll("[data-product-type]").forEach(button => {
    button.addEventListener("click", function () {
      state.productType = button.dataset.productType;
      state.userInput.usualSize = null;

      document.querySelectorAll("[data-product-type]").forEach(item => {
        item.classList.toggle("is-selected", item === button);
      });

      stepTypeError.classList.remove("is-visible");
      renderUsualSizeChoices(state.productType);

      const chart = SIZE_CHARTS[state.productType];
      productSubtitle.textContent = `Größenberater für ${chart.label}. Beantworte 3 kurze Fragen.`;
    });
  });

  document.querySelectorAll("[data-fit]").forEach(button => {
    button.addEventListener("click", function () {
      state.userInput.fit = button.dataset.fit;

      document.querySelectorAll("[data-fit]").forEach(item => {
        item.classList.toggle("is-selected", item === button);
      });

      step3Error.classList.remove("is-visible");
    });
  });

  backButton.addEventListener("click", function () {
    if (state.currentStep > 1) {
      state.currentStep -= 1;
      updateStep();
    }
  });

  nextButton.addEventListener("click", function () {
    if (!validateStep(state.currentStep)) return;

    if (state.currentStep < 4) {
      state.currentStep += 1;
      updateStep();
      if (state.currentStep === 2) {
        setTimeout(() => heightInput.focus(), 80);
      }
      return;
    }

    showRecommendations();
  });

  doneButton.addEventListener("click", closeModal);

  restartButton.addEventListener("click", function () {
    resetWizardView();
  });

  function openModal() {
    resetWizardView();
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function resetWizardView() {
    state.currentStep = 1;
    state.productType = null;
    state.userInput = {
      height: null,
      weight: null,
      usualSize: null,
      fit: null
    };

    heightInput.value = "";
    weightInput.value = "";

    document.querySelectorAll(".srf-choice").forEach(choice => choice.classList.remove("is-selected"));

    productSubtitle.textContent = "Wähle zuerst aus, was du anprobieren möchtest.";
    document.getElementById("srfUsualSizeChoices").innerHTML = "";

    wizard.hidden = false;
    wizard.style.display = "block";
    resultView.hidden = true;
    resultView.style.display = "none";
    footer.hidden = false;
    backButton.hidden = false;
    nextButton.hidden = false;
    doneButton.hidden = true;
    resultsContainer.innerHTML = "";

    clearErrors();
    updateStep();
  }

  function clearErrors() {
    [stepTypeError, step1Error, step2Error, step3Error].forEach(error => {
      error?.classList.remove("is-visible");
    });
  }

  function updateStep() {
    document.querySelectorAll(".srf-step").forEach(step => {
      const stepNumber = Number(step.dataset.step);
      const isActive = stepNumber === state.currentStep;

      step.classList.toggle("is-active", isActive);
      step.style.display = isActive ? "block" : "none";
    });

    document.querySelectorAll(".srf-progress-step").forEach(step => {
      const stepNumber = Number(step.dataset.progressStep);
      step.classList.toggle("is-active", stepNumber === state.currentStep);
      step.classList.toggle("is-complete", stepNumber < state.currentStep);
    });

    backButton.disabled = state.currentStep === 1;
    nextButton.textContent = state.currentStep === 4 ? "Größe empfehlen" : "Weiter";
  }

  function validateStep(step) {
    clearErrors();

    if (step === 1) {
      if (!state.productType) {
        stepTypeError.classList.add("is-visible");
        return false;
      }
      return true;
    }

    if (step === 2) {
      const height = Number(heightInput.value);
      const weight = Number(weightInput.value);

      const isValidHeight = height >= 130 && height <= 230;
      const isValidWeight = weight >= 35 && weight <= 180;

      if (!isValidHeight || !isValidWeight) {
        step1Error.classList.add("is-visible");
        return false;
      }

      state.userInput.height = height;
      state.userInput.weight = weight;
      return true;
    }

    if (step === 3) {
      if (!state.userInput.usualSize) {
        step2Error.classList.add("is-visible");
        return false;
      }
      return true;
    }

    if (step === 4) {
      if (!state.userInput.fit) {
        step3Error.classList.add("is-visible");
        return false;
      }
      return true;
    }

    return true;
  }

  function renderUsualSizeChoices(productType) {
    const container = document.getElementById("srfUsualSizeChoices");
    const chart = SIZE_CHARTS[productType];

    container.innerHTML = "";
    state.userInput.usualSize = null;

    chart.sizes.forEach(item => {
      const button = document.createElement("button");
      button.className = "srf-choice";
      button.type = "button";
      button.dataset.usualSize = item.size;
      button.textContent = item.size;

      button.addEventListener("click", function () {
        state.userInput.usualSize = item.size;

        container.querySelectorAll(".srf-choice").forEach(choice => {
          choice.classList.toggle("is-selected", choice === button);
        });

        step2Error.classList.remove("is-visible");
      });

      container.appendChild(button);
    });
  }

  function showRecommendations() {
    const chart = SIZE_CHARTS[state.productType];

    wizard.hidden = true;
    wizard.style.display = "none";

    resultView.hidden = false;
    resultView.style.display = "block";

    footer.hidden = false;
    backButton.hidden = true;
    nextButton.hidden = true;
    doneButton.hidden = false;

    resultsContainer.innerHTML = "";

    const rangeStatus = getFitRangeStatus(state.userInput, state.productType, chart);

    if (rangeStatus.status === "outside") {
      resultIntro.textContent = `Auf Basis deiner Angaben können wir für ${chart.label} aktuell keine sichere Größenempfehlung geben.`;

      const warning = document.createElement("div");
      warning.className = "srf-fit-warning";
      warning.innerHTML = `
        <strong>Keine sichere Empfehlung möglich</strong>
        <p>Die verfügbaren Größen könnten voraussichtlich zu schmal ausfallen. Wir möchten dir deshalb keine unsichere Größe empfehlen.</p>
      `;

      resultsContainer.appendChild(warning);
      return;
    }

    const recommendations = recommendSizes(state.userInput, state.productType, chart);

    resultIntro.textContent =
      `Basierend auf deiner Körpergröße, deinem Gewicht, deiner normalerweise getragenen Größe und deiner gewünschten Passform empfehlen wir dir diese Größe für ${chart.label}.`;

    if (rangeStatus.status === "borderline") {
      const warning = document.createElement("div");
      warning.className = "srf-fit-warning";
      warning.innerHTML = `
        <strong>Hinweis zur Passform</strong>
        <p>Deine Angaben liegen im oberen Bereich der verfügbaren Größentabelle. Wähle im Zweifel die größere Empfehlung.</p>
      `;
      resultsContainer.appendChild(warning);
    }

    recommendations.forEach((item, index) => {
      const card = document.createElement("article");
      card.className = "srf-result-card";
      card.classList.toggle("is-best", index === 0);

      card.innerHTML = `
        <div class="srf-result-top">
          <div>
            <div class="srf-result-size">${index + 1}. ${item.size}</div>
            <div class="srf-score">${item.score}% Übereinstimmung</div>
          </div>
          ${index === 0 ? `<span class="srf-badge">Beste Empfehlung</span>` : ""}
        </div>
        <p class="srf-reason">${item.reason}</p>
      `;

      resultsContainer.appendChild(card);
    });
  }

  function getFitRangeStatus(userInput, productType, sizeChart) {
    const bmi = userInput.weight / Math.pow(userInput.height / 100, 2);
    const largestIndex = sizeChart.sizes.length - 1;
    const estimatedAlpha = estimateAlphaSizeFromBody(userInput.height, userInput.weight, productType);
    const estimatedChartIndex = findClosestChartIndexByAlpha(sizeChart, estimatedAlpha);
    const usualSizeIndex = getChartIndexBySoldSize(sizeChart, userInput.usualSize);
    const fitAdjustment = getFitAdjustment(userInput.fit);
    const targetIndex = clamp(
      Math.round(averageValidIndexes([usualSizeIndex, estimatedChartIndex])) + fitAdjustment,
      0,
      largestIndex
    );

    const isVeryHighForTop = productType === "size_hose"
      ? bmi >= 32.5 && userInput.weight >= 105
      : bmi >= 33.5 && userInput.weight >= 110;

    const isExtremeOutside = productType === "size_hose"
      ? bmi >= 35 || userInput.weight >= 120
      : bmi >= 36 || userInput.weight >= 125;

    if (isExtremeOutside || (isVeryHighForTop && targetIndex >= largestIndex - 1)) {
      return { status: "outside" };
    }

    const isBorderline = productType === "size_hose"
      ? (bmi >= 30 && userInput.weight >= 95 && targetIndex >= largestIndex - 1)
      : (bmi >= 31 && userInput.weight >= 100 && targetIndex >= largestIndex - 1);

    if (isBorderline) {
      return { status: "borderline" };
    }

    return { status: "ok" };
  }

  function recommendSizes(userInput, productType, sizeChart) {
    const usualSizeIndex = getChartIndexBySoldSize(sizeChart, userInput.usualSize);
    const estimatedAlpha = estimateAlphaSizeFromBody(userInput.height, userInput.weight, productType);
    const estimatedChartIndex = findClosestChartIndexByAlpha(sizeChart, estimatedAlpha);
    const fitAdjustment = getFitAdjustment(userInput.fit);

    const baseTargetIndex = Math.round(averageValidIndexes([usualSizeIndex, estimatedChartIndex]));
    const fitTargetIndex = clamp(baseTargetIndex + fitAdjustment, 0, sizeChart.sizes.length - 1);

    const scored = sizeChart.sizes.map((chartItem, index) => {
      let score = 100;

      if (usualSizeIndex !== -1) {
        score -= Math.abs(usualSizeIndex - index) * 14;
      }

      if (estimatedChartIndex !== -1) {
        score -= Math.abs(estimatedChartIndex - index) * 12;
      }

      score -= Math.abs(fitTargetIndex - index) * 10;
      score += getProductTypeBonus(userInput, productType, chartItem);
      score = clamp(Math.round(score), 45, 99);

      return {
        size: chartItem.size,
        alpha: chartItem.alpha,
        score,
        index
      };
    });

    const sorted = scored.sort((a, b) => b.score - a.score).slice(0, 3);
    const bestIndex = sorted[0]?.index ?? fitTargetIndex;

    return sorted.map((item, position) => ({
      size: item.size,
      score: item.score,
      reason: getReason(position, item.index, bestIndex)
    }));
  }

  function getChartIndexBySoldSize(sizeChart, soldSize) {
    return sizeChart.sizes.findIndex(item => item.size === soldSize);
  }

  function findClosestChartIndexByAlpha(sizeChart, alpha) {
    const exactIndex = sizeChart.sizes.findIndex(item => item.alpha === alpha);
    if (exactIndex !== -1) return exactIndex;

    const targetAlphaIndex = SIZE_ORDER.indexOf(alpha);
    if (targetAlphaIndex === -1) return -1;

    let closestIndex = 0;
    let closestDistance = Infinity;

    sizeChart.sizes.forEach((item, index) => {
      const itemAlphaIndex = SIZE_ORDER.indexOf(item.alpha);
      const distance = Math.abs(itemAlphaIndex - targetAlphaIndex);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function averageValidIndexes(indexes) {
    const validIndexes = indexes.filter(index => index !== -1);
    if (!validIndexes.length) return 0;
    return validIndexes.reduce((sum, index) => sum + index, 0) / validIndexes.length;
  }

  function estimateAlphaSizeFromBody(height, weight, productType) {
    const bmi = weight / Math.pow(height / 100, 2);
    let alpha = "M";

    if (bmi < 20.5) alpha = "S";
    else if (bmi < 23.5) alpha = "M";
    else if (bmi < 26.5) alpha = "L";
    else if (bmi < 29.5) alpha = "XL";
    else alpha = "XXL";

    if (height >= 190 && (alpha === "S" || alpha === "M")) {
      alpha = nextSize(alpha);
    }

    if (height <= 168 && (alpha === "XL" || alpha === "XXL")) {
      alpha = previousSize(alpha);
    }

    if (productType === "size_hose" && bmi >= 26.5) {
      alpha = nextSize(alpha);
    }

    return alpha;
  }

  function getFitAdjustment(fit) {
    if (fit === "tight") return -1;
    if (fit === "loose") return 1;
    return 0;
  }

  function getProductTypeBonus(userInput, productType, chartItem) {
    let bonus = 0;

    if (productType === "size_hemd") {
      if (userInput.height >= 185 && chartItem.sleeve >= 67) bonus += 4;
      if (userInput.weight >= 85 && chartItem.halfChest >= 55) bonus += 4;
    }

    if (productType === "size_pullover") {
      if (userInput.height >= 185 && chartItem.length >= 71) bonus += 4;
      if (userInput.weight >= 85 && chartItem.halfChest >= 54) bonus += 4;
    }

    if (productType === "size_hose") {
      if (userInput.weight >= 85 && chartItem.halfWaist >= 45) bonus += 5;
      if (userInput.fit === "loose" && chartItem.halfThigh >= 36) bonus += 4;
    }

    return bonus;
  }

  function getReason(position, recommendationIndex, bestIndex) {
    if (position === 0) return "Beste Übereinstimmung mit deinen Angaben.";
    if (recommendationIndex > bestIndex) return "Gute Alternative, wenn du es lockerer willst.";
    if (recommendationIndex < bestIndex) return "Alternative, wenn du es enger willst.";
    return "Gute Alternative mit ähnlicher Passform.";
  }

  function nextSize(alpha) {
    const index = SIZE_ORDER.indexOf(alpha);
    return SIZE_ORDER[clamp(index + 1, 0, SIZE_ORDER.length - 1)];
  }

  function previousSize(alpha) {
    const index = SIZE_ORDER.indexOf(alpha);
    return SIZE_ORDER[clamp(index - 1, 0, SIZE_ORDER.length - 1)];
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }
})();
